
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mahashivratri/shiva/[blog]",
      function () {
        return require("private-next-pages/mahashivratri/shiva/[blog]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mahashivratri/shiva/[blog]"])
      });
    }
  